import React from "react";
import { RouteComponentProps, Link } from "@reach/router";

const ComingSoon: React.FC<RouteComponentProps> = () => {
  return (
    <div className="NotFound">
      <h1>Coming soon!</h1>
      <p>
        Return to <span><Link to="/">homepage</Link></span>
      </p>
    </div>
  );
};

export default ComingSoon;
